import { render, staticRenderFns } from "./PlatformProductForm.vue?vue&type=template&id=7c928b1e&"
import script from "./PlatformProductForm.vue?vue&type=script&lang=js&"
export * from "./PlatformProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports